import {
  GET_CIVILBUDGETCONTROL,
  GET_CIVILBUDGETCONTROL_SUCCESS,
  GET_CIVILBUDGETCONTROL_FAIL,
  DELETE_CIVILBUDGETCONTROL,
  DELETE_CIVILBUDGETCONTROL_SUCCESS,
  DELETE_CIVILBUDGETCONTROL_FAIL,
  UPDATE_CIVILBUDGETCONTROL,
  UPDATE_CIVILBUDGETCONTROL_SUCCESS,
  UPDATE_CIVILBUDGETCONTROL_FAIL,
  ADD_NEW_CIVILBUDGETCONTROL,
  ADD_CIVILBUDGETCONTROL_SUCCESS,
  ADD_CIVILBUDGETCONTROL_FAIL,
  CIVILBUDGETCONTROL_LOADING,
  CIVILBUDGETCONTROL_RESET
} from "./actionType";

export const resetCivilBudgetControlState = (actionType) => ({
  type: CIVILBUDGETCONTROL_RESET,
  payload: { actionType },
});

export const getCivilBudgetControlSuccess = (actionType, data) => ({
  type: GET_CIVILBUDGETCONTROL_SUCCESS,
  payload: { actionType, data },
});

export const getCivilBudgetControlFail = (actionType, error) => ({
  type: GET_CIVILBUDGETCONTROL_FAIL,
  payload: { actionType, error },
});

export const getCivilBudgetControl = data => ({
  type: GET_CIVILBUDGETCONTROL,
  payload: data,
});

export const getCivilBudgetControlLoading = () => ({
  type: CIVILBUDGETCONTROL_LOADING
});

export const deleteCivilBudgetControl = data => ({
  type: DELETE_CIVILBUDGETCONTROL,
  payload: data,
});

export const deleteCivilBudgetControlSuccess = data => ({
  type: DELETE_CIVILBUDGETCONTROL_SUCCESS,
  payload: data,
});

export const deleteCivilBudgetControlFail = error => ({
  type: DELETE_CIVILBUDGETCONTROL_FAIL,
  payload: error,
});

export const updateCivilBudgetControl = data => ({
  type: UPDATE_CIVILBUDGETCONTROL,
  payload: data,
});

export const updateCivilBudgetControlFail = error => ({
  type: UPDATE_CIVILBUDGETCONTROL_FAIL,
  payload: error,
});

export const updateCivilBudgetControlSuccess = data => ({
  type: UPDATE_CIVILBUDGETCONTROL_SUCCESS,
  payload: data,
});

export const addNewCivilBudgetControl = data => ({
  type: ADD_NEW_CIVILBUDGETCONTROL,
  payload: data,
});

export const addCivilBudgetControlSuccess = data => ({
  type: ADD_CIVILBUDGETCONTROL_SUCCESS,
  payload: data,
});

export const addCivilBudgetControlFail = error => ({
  type: ADD_CIVILBUDGETCONTROL_FAIL,
  payload: error,
});